import styled, { css } from 'styled-components';
const containerSizeMap = {
    large: 48,
    medium: 40,
    small: 32,
    micro: 24,
};
export const Container = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--icon-primary);
  background: var(--bg-secondary);
  border-radius: var(--radius-brand);
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: var(--bg-secondary-hover);
  }

  &:active {
    background: var(--bg-secondary-active);
  }

  &:disabled {
    background: var(--bg-secondary);
    opacity: 0.4;
    cursor: not-allowed;
  }

  height: ${({ $size }) => containerSizeMap[$size]}px;
  width: ${({ $size }) => containerSizeMap[$size]}px;

  ${({ $variant }) => $variant === 'transparent' &&
    css `
      background: transparent;

      &:hover {
        background: var(--bg-transparent);
      }

      &:active {
        background: var(--bg-transparent-strong);
      }

      &:disabled {
        background: transparent;
        opacity: 0.4;
      }
    `}

  ${({ $variant }) => $variant === 'semi-transparent' &&
    css `
      background: var(--bg-transparent);

      &:hover {
        background: var(--bg-transparent-strong);
      }

      &:active {
        background: var(--bg-transparent-strongest);
      }

      &:disabled {
        background: var(--bg-transparent);
        opacity: 0.4;
      }
    `}

  ${({ $variant }) => $variant === 'outline' &&
    css `
      background: var(--bg-primary);
      border: 1px solid var(--border-transparent-strongest);

      &:hover {
        background: var(--bg-primary-hover);
      }

      &:active {
        background: var(--bg-transparent-strongest);
      }

      &:disabled {
        background: var(--bg-primary);
        opacity: 0.4;
      }
    `}
`;
